import { SupportingDocument } from "../../constants/common";
import { cn } from "../../utils/cn";

const CheckboxPermitPDF: React.FC<{
    item: SupportingDocument;
    isLastColumn: boolean;
    checked?: boolean;
}> = ({ item, checked = false }) => (
    <div
        className={cn(
            "grid grid-cols-12 border-b border-black",
            item.label === "" && "h-[21px]" // Fixed height for empty rows
        )}
    >
        <div className="col-span-10 px-1 py-0.5 text-[10px] flex items-center">
            {item.label && (
                <>
                    {item.label}
                    {/* {item.mandatory && (
                        <span className="text-red-500 ml-1 text-[8px]">Mandatory</span>
                    )} */}
                </>
            )}
        </div>
        <div className="col-span-2 px-1 py-0.5 flex justify-center items-center border-l border-black">
            <div className="w-7 h-4 border border-black flex items-center justify-center text-[10px]">
                {checked ? "✓" : ""}
            </div>
        </div>
    </div>
);

export default CheckboxPermitPDF;